import React from 'react';
import "../App.css";

const Header = () => {
    return (

        <div className="header-logo">
            <div className="header-logo-image">
                <img src="/logo.png" alt="header-logo" />
            </div>

            <h3>Tv Mounting Service</h3>
        </div>




    );
}

export default Header;